// extracted by mini-css-extract-plugin
export default {"container":"qp-z","heading":"rp-z","text":"sp-z","info":"tp-z","link":"up-z","fullMaxWidth":"vp-z"};